import React from "react";
import SidebarContentWrapper from "../../layout/sidebarContentLayout";
import ContentSliderItem from "../../components/drawer-slider-item/drawer-slider-item";
import "./sidebar-content.css";

const SidebarContent = (props) => {
  return (
    <aside
      className={`${props.isSidebarOpen ? "sidebar show-sidebar" : "sidebar"}`}
      //className="sidebar"
      style={{
        backgroundColor: `#fff`,
      }}
    >
      <div className="sidebar-header">
        <button className="close-btn" onClick={props.sidebarToggle}>
          <i className="ggdsicon-close text-size-150"></i>
        </button>
      </div>
      <SidebarContentWrapper
        drawerBgColor={props.drawerBgColor}
        defaultBgColor={props.defaultBgColor}
        //screenStatus={props.screenStatus}
        isSidebarOpen={props.isSidebarOpen}
      >
      <div className="sidebar-items-wrapper">
        {props.contentSliderDataArr.map((slideInfo) => {
          return (
            <ContentSliderItem
              key={slideInfo.id}
              imageUrl={slideInfo.imageUrl}
              mobileImageUrl = {slideInfo.mobileImageUrl}
              imageAlt={slideInfo.imageAlt}
              redirectURL={slideInfo.redirectURL}
              description={slideInfo.description}
              position={slideInfo.id}
              drawerType = "Side"
            />
          );
        })}
      </div>
      </SidebarContentWrapper>
    </aside>
  );
};

export default SidebarContent;
